import { useCallback, useEffect, useState } from 'react';
import { Network, networksService } from '../services/firebaseFunctions';

const getErrorMessage = (error: unknown) => (
  error instanceof Error ? error.message : 'Não foi possível concluir a operação'
);

export const useNetworks = () => {
  const [networks, setNetworks] = useState<Network[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      setNetworks(await networksService.list());
    } catch (caught) {
      setError(getErrorMessage(caught));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  const mutate = async <T,>(action: () => Promise<T>) => {
    try {
      const result = await action();
      await refresh();
      return result;
    } catch (caught) {
      setError(getErrorMessage(caught));
      throw caught;
    }
  };

  return {
    networks,
    loading,
    error,
    refresh,
    create: (data: { name: string; description?: string }) => mutate(() => networksService.create(data)),
    update: (id: string, data: { name?: string; description?: string | null }) => mutate(() => networksService.update(id, data)),
    remove: (id: string) => mutate(() => networksService.delete(id)),
  };
};
